import React from 'react'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import de from 'date-fns/locale/de'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
  datePicker: {
    fontSize: '14px',
  },
}))

interface IDatesProps {
  value?: Date | null
  fullWidth?: boolean
  onChangeDate?: (date: Date | null) => void
  timePicker?: boolean
  label?: string
  disabled?: boolean
  helperText?: string
  minDate?: Date
  maxDate?: Date
  inputVariant?: string
  size?: 'medium' | 'small' | undefined
}

const DatePickerComponent: React.FC<IDatesProps> = (props) => {
  const classes = useStyles()

  const changeValue = (date: Date | null) => {
    props.onChangeDate && props.onChangeDate(date)
  }

  return (
    <div className={classes.root}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
        {
          props.timePicker
            ? (
              <DateTimePicker
                sx={{ width: props.fullWidth ? '100%' : 'auto' }}
                className={classes.datePicker}
                label={props.label}
                value={props.value}
                minDate={props.minDate}
                maxDate={props.maxDate}
                disabled={props.disabled}
                onChange={(date: Date | null) => {
                  changeValue(date)
                }}
              />
            )
            : (
              <DatePicker
                sx={{ width: props.fullWidth ? '100%' : 'auto' }}
                className={classes.datePicker}
                label={props.label}
                value={props.value}
                onChange={(date: Date | null) => {
                  changeValue(date)
                }}
                minDate={props.minDate}
                maxDate={props.maxDate}
                disabled={props.disabled}
              />
            )
        }
      </LocalizationProvider>
    </div>
  )
}
export default DatePickerComponent
